import {FC} from "react";
import { toast } from "react-toastify";
import {useDeleteAdMutation} from "./__generated__/AdsDelete.mutation.generated";
import useDrawer from "../../../hooks/useDrawer";
import {Contentbar} from "../../../ui/Sidebar";


const AdsDelete:FC = () => {
  const { id, closeChildrenHandler } = useDrawer();

  const [deleteHandler, { loading }] = useDeleteAdMutation({
    variables: { id },
    onCompleted: () => {
      toast.success('Удаление выполнено!');
      closeChildrenHandler();
    },
    onError: () => {
      toast.error('При удалении произошла ошибка');
    }
  });

  return (
    <Contentbar isLoading={loading} onClose={closeChildrenHandler} onSubmit={deleteHandler}>
      <h2>Вы точно уверены?</h2>
      <p><b>Внимание!</b> Удаление происиходит безвовратно, удаленые данные восстановлению не подлежать.</p>
      <p>Для продолжения нажмите кнопку <b>"Подтвердить".</b></p>
    </Contentbar>
  )
}

export default AdsDelete;
